// extracted by mini-css-extract-plugin
module.exports = {"Note":"pQcpM6I4","pinned":"_3XaMdTSi","date":"N8tMLS6O","dateElement":"WAbZKSiU","noteContent":"_2OHJfQZ5"};